(function () {
  function setup(root) {
    var content = root.querySelector('.lushe-readmore__content');
    var toggle = root.querySelector('[data-lushe-readmore-toggle]');
    if (!content || !toggle) return;

    // Only clamp when the text is actually taller than the preview height,
    // otherwise short descriptions get a pointless "Read more" button.
    var clampHeight = parseFloat(getComputedStyle(content).maxHeight);
    var overflows = content.scrollHeight > clampHeight + 8;

    root.classList.toggle('is-clamped', overflows);
    toggle.hidden = !overflows;
    if (!overflows) {
      root.classList.remove('is-expanded');
      return;
    }

    toggle.textContent = toggle.getAttribute('data-more-text');
    toggle.setAttribute('aria-expanded', 'false');
  }

  function onClick(event) {
    var toggle = event.target.closest('[data-lushe-readmore-toggle]');
    if (!toggle) return;

    var root = toggle.closest('[data-lushe-readmore]');
    if (!root) return;

    var expanded = root.classList.toggle('is-expanded');
    toggle.textContent = toggle.getAttribute(expanded ? 'data-less-text' : 'data-more-text');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (!expanded) {
      root.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  function init() {
    document.querySelectorAll('[data-lushe-readmore]').forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('click', onClick);
  // Variant changes re-render the product info block in Dawn.
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', init);
})();
